import React from 'react'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { TextField } from "@material-ui/core";

export default function DatePicker(props) {

    const { name, label, value, onChange, error = null, defaultMessage } = props


    const convertToDefEventPara = (name, value) => ({
        target: {
            name, value
        }
    })

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker 
                label={label}
                format="MMM/dd/yyyy"
                name={name}
                value={value}
                onChange={date =>onChange(convertToDefEventPara(name,date))}
                {...(error && {error:true,helperText:error})}
                {...(defaultMessage&& {required: true})}
                disableOpenOnEnter
                inputProps={{ readOnly: true }} 
                onClick={(e) => e.currentTarget.querySelector('button')?.click()} 
                TextFieldComponent={(props) => (
                    <TextField
                        {...props}
                        variant="outlined"
                        fullWidth
                        InputProps={{
                            ...props.InputProps,
                            style: { borderRadius: 4 } 
                        }}
                    />
                )}
            />
        </MuiPickersUtilsProvider>
    )
}
